export default "__VITE_ASSET__BN_a1qAQ__"